import {
  createLogForApproval,
  createLogForReview,
  createLogPublished,
  createNotificationForApproval,
  createNotificationForReview,
  updateQuestionApprover,
  updateQuestionReviewer,
  updateQuestionStatus,
} from 'gql/mutations'
import { getWorkRequestStatusCount } from 'helpers/getWorkRequestStatusCount'
import { createMailForApproval, createMailForReview } from 'helpers/mails'

export const submitForApprovalOrReview = async (
  requestType: string,
  selectedQuestions: any,
  request: any,
  userRole: string,
  qreviewerList: any,
  user: any,
  qapproverList: any
) => {
  const totalQuestionNumbers = selectedQuestions?.length
  if ((userRole === 'qcreator' || userRole === 'variantcreator') && requestType === 'For Review') {
    const reviewers = request?.reviewer_ids
    if (reviewers?.length > 0) {
      selectedQuestions.map(async (questionId: any) => {
        let { for_review_count, reviewed_count, approved_count, for_approval_count, rejected_count, retired_count } = await getWorkRequestStatusCount(
          request
        )
        let reviewerIndex =
          (for_review_count + reviewed_count + rejected_count + retired_count + approved_count + for_approval_count) % reviewers?.length
        let reviewerId = request.reviewer_ids[reviewerIndex]
        if (reviewerId) {
          let reviewerDetails = qreviewerList.filter((reviewers: any) => reviewers?.id === reviewerId)[0]
          updateQuestionStatus(questionId, 'For Review')
            .then(() => updateQuestionReviewer(questionId, reviewerId))
            .then(() => createNotificationForReview(user?.id, reviewerId, request, questionId))
            .then(() => createLogForReview(reviewerId, request, questionId))
            .then(() => getWorkRequestStatusCount(request))
            .then(() => {
              createMailForReview(request, questionId, reviewerDetails?.user?.displayName, reviewerDetails?.user?.email)
            })
            .catch(err => {
              console.log(err, 'err')
            })
        }
      })
    } else {
      return { message: "Can't send to review, you have to select atleast one reviewer" }
    }
  } else if (userRole === 'qreviewer' && requestType === 'For Approval') {
    const questions = request?.questions
    const approvers = request?.all_approver_ids
    const { for_approval_count, approved_count, rejected_count, retired_count } = await getWorkRequestStatusCount(request)
    const approverIndex = (for_approval_count + approved_count + rejected_count + retired_count) % approvers?.length
    const approverId = approvers[approverIndex]
    const approverDetails = qapproverList.filter((appUser: any) => appUser?.id === approverId)[0]
    if (approverId) {
      selectedQuestions?.map(async (questionId: string) => {
        const questionDetails = questions.filter((question: any) => question?.id === questionId)[0]

        updateQuestionStatus(questionId, 'For Approval')
          .then(() => updateQuestionApprover(questionId, approverId))
          .then(() => createNotificationForApproval(user?.id, approverId, request, questionId))
          .then(() => createLogForApproval(questionDetails?.reviewer_id, approverId, request, questionDetails?.id))
          .then(() => getWorkRequestStatusCount(request))
          .then(() => createMailForApproval(request, questionDetails?.id, approverDetails?.user?.displayName, approverDetails?.user?.email))
          .catch(err => console.log(err))
      })
    } else {
      return { message: "Can't send to approval, you have to select atleast one approver" }
    }
  } else if (userRole === 'qapprover' && requestType === 'Published') {
    const questions = request?.questions
    selectedQuestions?.map(async (questionId: string) => {
      const questionDetails = questions.filter((question: any) => question?.id === questionId)[0]
      updateQuestionStatus(questionDetails.id, 'Published')
        .then(() => getWorkRequestStatusCount(request))
        .then(() => createLogPublished(questionDetails?.approver_id, request, questionDetails?.id))
        .catch(err => console.log(err))
    })
  }
}
